import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
    render() {
      return (
        <div className='Header Header-bottom'>
          <div className='Header-topBar'>
            <a href={'/'}>
              <img alt={'Logo'} className={'Header-logo'} src={'https://storage.googleapis.com/ctrlv-www/v2/2018/08/4f8532d2-png-ctrl-v-400.png'} />
            </a>
          </div>
          {/* <div className='Header-message' key={Math.random()}>
            <div className={'Header-header'}>Payment Complete</div>
            <div className={'Header-subHeader'}>PLEASE ARRIVE 20 MINUTES BEFORE YOUR SCHEDULED APPOINTMENT</div>
          </div>
          <div className="Header-encourage" id={(this.props.is_real_booking)? "dont-hide" : "hide"}>
            <div className="Header-encourage-message">THESE WILL HELP MAKE THE CHECK-IN PROCESS SUPER QUICK!</div>
          </div> */}
        </div>
      );
    }
  }

  export default Header;